import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["relationship", "title", "permissionLevel", "submitBtn",
                     "nameField", "emailField", "auctionParticipant"];

  static values = {
    defaultTitle: { type: String, default: "Invite Member" },
  };

  connect() {
    this.validateForm()
  }

  setContext({ params: { type } }) {
    const config = this.configFor(type);

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = config.title;
    }

    if (this.hasRelationshipTarget) {
      this.relationshipTarget.value = config.defaultRelationship;
      this.toggleOptgroups(config.showGroup);
    }

    if (this.hasPermissionLevelTarget && config.defaultPermissionLevel) {
      this.permissionLevelTarget.value = config.defaultPermissionLevel;
    }

    this.validateForm()
  }

  reset() {
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = this.defaultTitleValue;
    }

    if (this.hasRelationshipTarget) {
      this.relationshipTarget.value = "";
      this.showAllOptgroups();
    }

    if (this.hasPermissionLevelTarget) {
      this.permissionLevelTarget.value = "";
    }

    this.validateForm()
  }

  validateForm() {
    if (!this.hasSubmitBtnTarget) return

    const nameOk = !this.hasNameFieldTarget || this.nameFieldTarget.value.trim() !== ""
    const emailVal = this.hasEmailFieldTarget ? this.emailFieldTarget.value.trim() : ""
    const emailOk = !this.hasEmailFieldTarget || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailVal)
    const relationshipOk = !this.hasRelationshipTarget || this.relationshipTarget.value !== ""
    const auctionChecked = this.hasAuctionParticipantTarget && this.auctionParticipantTarget.checked
    const permissionOk = auctionChecked || (this.hasPermissionLevelTarget && this.permissionLevelTarget.value !== "")

    this.submitBtnTarget.disabled = !(nameOk && emailOk && relationshipOk && permissionOk)
  }

  configFor(type) {
    const configs = {
      family: {
        title: "Invite Family Member",
        defaultRelationship: "spouse",
        defaultPermissionLevel: "viewer",
        showGroup: "family",
      },
      attorney: {
        title: "Invite Attorney / Lawyer",
        defaultRelationship: "attorney",
        defaultPermissionLevel: "viewer",
        showGroup: "professional",
      },
      accountant: {
        title: "Invite Accountant",
        defaultRelationship: "accountant",
        defaultPermissionLevel: "viewer",
        showGroup: "professional",
      },
      professional: {
        title: "Invite Professional",
        defaultRelationship: "",
        defaultPermissionLevel: "viewer",
        showGroup: "professional",
      },
    };

    return (
      configs[type] || {
        title: this.defaultTitleValue,
        defaultRelationship: "",
        defaultPermissionLevel: "",
        showGroup: "all",
      }
    );
  }

  toggleOptgroups(showGroup) {
    const optgroups = this.relationshipTarget.querySelectorAll("optgroup");
    optgroups.forEach((group) => {
      if (showGroup === "all") {
        group.style.display = "";
        this.enableOptions(group);
      } else if (
        showGroup === "family" &&
        group.label === "Family Members"
      ) {
        group.style.display = "";
        this.enableOptions(group);
      } else if (
        showGroup === "professional" &&
        group.label === "Professional Advisors"
      ) {
        group.style.display = "";
        this.enableOptions(group);
      } else {
        group.style.display = "none";
        this.disableOptions(group);
      }
    });
  }

  showAllOptgroups() {
    const optgroups = this.relationshipTarget.querySelectorAll("optgroup");
    optgroups.forEach((group) => {
      group.style.display = "";
      this.enableOptions(group);
    });
  }

  enableOptions(optgroup) {
    optgroup.querySelectorAll("option").forEach((opt) => {
      opt.disabled = false;
    });
  }

  disableOptions(optgroup) {
    optgroup.querySelectorAll("option").forEach((opt) => {
      opt.disabled = true;
    });
  }
}
